import { Theme } from '@mui/material/styles';
import { glassSurface } from '../glass';

// ----------------------------------------------------------------------

export default function Paper(theme: Theme) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          ...glassSurface(theme),
        },
      },
    },
  };
}
